<script setup lang="ts">
import { NavigationMenuContent as RadixNavigationMenuContent, type NavigationMenuContentProps, useForwardProps } from 'reka-ui'

const props = defineProps<NavigationMenuContentProps>()

const forwarded = useForwardProps(props)
</script>

<template>
  <RadixNavigationMenuContent v-bind="forwarded"
                              class="absolute top-full left-1/2 transform -translate-x-1/2 flex flex-col gap-1 z-100 min-w-64 overflow-hidden rounded-lg bg-background text-primary-500 shadow-[0px_12px_16px_-4px_rgba(16,24,40,0.08),0px_4px_6px_-2px_rgba(16,24,40,0.03)] data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95">
    <slot />
  </RadixNavigationMenuContent>
</template>
